import React from 'react';
import './assets/scss/themes.scss';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LayoutProvider } from './context/LayoutContext';
import { TariffProvider } from './context/TariffContext';
import { AboutUsProvider } from './context/AboutUsContext';
import { ContactMessageProvider } from './context/ContactMessageContext';
import { FaqProvider } from './context/FaqContext';
import { CoinRequestProvider } from './context/CoinRequestContext';
import { BlogCategoryProvider } from './context/BlogCategoryContext';
import { BlogPostProvider } from './context/BlogPostContext'; 
import { CommentProvider } from './context/CommentContext'; 
import { DashboardProvider } from './context/DashboardContext'; 
import NonAuthLayout from './Layouts/NonAuthLayout';
import Layout from './Layouts/index';
import AuthProtected from './Routes/AuthProtected';
import { authProtectedRoutes, publicRoutes } from './Routes/allRoutes';

function App() {
  return (
    <AuthProvider>
      <LayoutProvider>
        <TariffProvider>
          <AboutUsProvider>
            <ContactMessageProvider>
              <FaqProvider>
                <CoinRequestProvider>
                  <BlogCategoryProvider>
                    <BlogPostProvider>
                      <CommentProvider>
                      <DashboardProvider>
                      <Routes>
                        {publicRoutes.map((route, idx) => (
                          <Route
                            key={idx}
                            path={route.path}
                            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                          />
                        ))}
                        {authProtectedRoutes.map((route, idx) => (
                          <Route
                            key={idx}
                            path={route.path}
                            element={
                              <AuthProtected>
                                <Layout>{route.component}</Layout>
                              </AuthProtected>
                            }
                          />
                        ))}
                      </Routes>
                      </DashboardProvider>
                      </CommentProvider>
                    </BlogPostProvider>
                  </BlogCategoryProvider>
                </CoinRequestProvider>
              </FaqProvider>
            </ContactMessageProvider>
          </AboutUsProvider>
        </TariffProvider>
      </LayoutProvider>
    </AuthProvider>
  );
}

export default App;